<template>
  <v-app>
    <transition name="fade-slow" mode="out-in">
      <router-view v-if="!authorized" />
      <BLayoutEmpty v-else-if="!ready" loading />
    </transition>
  </v-app>
</template>

<script>
import { rootMapper } from '@/store/modules/root'
import { getProjectName } from '@/helpers/projectName'
import BLayoutEmpty from '@/components/layouts/BLayoutEmpty.vue'


export default {
  name: 'BLayoutAuth',
  components: {
    BLayoutEmpty,
  },
  props: {
    ready: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...rootMapper.mapGetters(['authorized']),
  },
  created() {
    document.body.classList.add('layout-auth')
    document.title = getProjectName()
  },
  destroyed() {
    document.body.classList.remove('layout-auth')
  },
}
</script>

<style lang="scss" src="@/assets/scss/transitions/transition-fade.scss"></style>
